import * as React from "react";
import { FlagsProvider } from "./src/context/flags";

// Wrap the root element so flags are fetched once per session, not on
// every client-side navigation (each page renders <Layout> directly).
export function wrapRootElement({ element }) {
  return <FlagsProvider>{element}</FlagsProvider>;
}
